import React from "react";

const LOGO_URL_WEBP = "/brand/smart-hub-logo.webp";
const LOGO_URL_PNG = "/brand/smart-hub-favicon.png"; // small 128px fallback

/**
 * SMART HUB brand logo — circular medallion variant.
 * Sizes: 24 / 32 / 36 / 40 / 48 (px). Accepts custom className/size override.
 */
export function Logo({ size = 36, className = "", glow = false, alt = "SMART HUB" }) {
  const s = typeof size === "number" ? `${size}px` : size;
  return (
    <span
      className={`relative inline-flex items-center justify-center shrink-0 ${className}`}
      style={{ width: s, height: s }}
    >
      {glow && (
        <span
          aria-hidden
          className="absolute inset-0 rounded-full"
          style={{ background: "radial-gradient(circle, rgba(59,130,246,0.45) 0%, rgba(255,211,106,0.25) 60%, transparent 80%)", filter: "blur(10px)" }}
        />
      )}
      <picture>
        <source srcSet={LOGO_URL_WEBP} type="image/webp" />
        <img
          src={LOGO_URL_PNG}
          alt={alt}
          draggable={false}
          decoding="async"
          fetchpriority="high"
          className="relative w-full h-full object-contain rounded-full select-none"
          style={{ filter: "drop-shadow(0 4px 14px rgba(0,0,0,0.45))" }}
        />
      </picture>
    </span>
  );
}

export default Logo;
